import {connect} from 'react-redux';
import CountryFieldComponent from './countryImpl';

const mapStateToProps = (state, props) => ({
  ...props,
  countries: state.locale.countriesForISOs
});

export default connect(mapStateToProps)(CountryFieldComponent);
